module.exports = __webpack_public_path__ + "ubuntu-bold-webfont.80f5068d436bb0e07928.woff2";


//////////////////
// WEBPACK FOOTER
// ./src/assets/webfonts/ubuntu/ubuntu-bold-webfont.woff2
// module id = ./src/assets/webfonts/ubuntu/ubuntu-bold-webfont.woff2
// module chunks = styles